/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponsePendingMessageImportResult } from '../../models/api-response-pending-message-import-result';
import { PendingMessageImportRow } from '../../models/pending-message-import-row';

export interface ImportPendingMessages$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
      body: Array<PendingMessageImportRow>
}

export function importPendingMessages(http: HttpClient, rootUrl: string, params: ImportPendingMessages$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePendingMessageImportResult>> {
  const rb = new RequestBuilder(rootUrl, importPendingMessages.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponsePendingMessageImportResult>;
    })
  );
}

importPendingMessages.PATH = '/v1/api/pending-messages/import-csv';
